<template>
  <div class="listContentManage">
    <!-- 表格 -->
    <basic-container>
      <div class="query-form-wrap">
        <el-form :inline="true" :model="searchForm" :size="formSize" label-width="88px">
          <el-form-item >
            <el-input v-model="searchForm.name" placeholder="应用名称"></el-input>
          </el-form-item>
          <el-form-item >
            <el-select size="small" filterable clearable v-model="searchForm.type" placeholder="应用类型">
              <el-option v-for="(item, index) in aplicationTypeList " :key="index" :label="item.bizValue"
                :value="item.bizKey"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button v-auth="'PULL_APP_MANAGE_SEARCH'" :loading="listLoading"  type="primary" @click="getListContent(1)">搜索</el-button>
            <el-button  v-auth="'PULL_APP_MANAGE_ADD'" plain  @click="handleClick('', 1)">新增</el-button>
          </el-form-item>
        </el-form>
        <el-table border :data="tableData" height="600px" style="width: 100%">
          <el-table-column prop="id" label="ID" width="180">
          </el-table-column>
          <el-table-column prop="name" label="应用名称" width="180">
          </el-table-column>
          <el-table-column prop="type" label="应用类型" width="180">
            <template slot-scope="scope">
              {{ getApplicationDes(scope.row.type) }}
            </template>
          </el-table-column>
          <el-table-column prop="icon" label="应用icon" width="180">
            <template slot-scope="scope">
              <el-image
                style="width: 50px; height: 50px"
                :src="scope.row.icon"
                :preview-src-list="[scope.row.icon]"
                @click.stop="handleClickItem">
              </el-image>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间">
          </el-table-column>
          <el-table-column prop="remark" label="备注">
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-button v-auth="'PULL_APP_MANAGE_LOG'" @click="viewLog(scope.row)" type="text" size="small">日志</el-button>
              <el-button v-auth="'PULL_APP_MANAGE_EDIT'" @click="handleClick(scope.row, 2)" type="text" size="small">编辑</el-button>
              <el-button v-auth="'PULL_APP_MANAGE_DEL'" @click="handleClick(scope.row, 3)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.current"
            :page-sizes="[10, 50, 100, 200]"
            :page-size="pagination.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total">
          </el-pagination>
        </div>
      </div>
    </basic-container>
    <!-- 新增/编辑弹窗 -->
    <el-dialog  :title="type===1?'新增':'编辑'"  append-to-body :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="visible" width="800px" @close="onDialogClose">
      <div v-loading="loading" class="dialog-content-wrap">
        <el-collapse v-model="activeNames" accordion>
            <el-collapse-item  name="1">
              <template slot="title">
               <b>基础配置</b><i class="header-icon el-icon-info"></i>
              </template>
              <el-form :model="dialogForm" :rules="rules" ref="editForm" size="small" label-width="140px">
                <el-form-item v-for="(item) in dialogForm" :key="item.id" :label="item.label" :prop="item.name" :ref="item.name">
                  <!-- 文本框 -->
                  <el-input v-if="item.type === 'input'" v-model="item.value" style="width: 400px;" :placeholder="item.placeholder"></el-input>
                  <!-- 下拉选择 -->
                  <el-select  v-if="item.type === 'select'" v-model="item.value" :placeholder="item.placeholder">
                    <el-option v-for="item in aplicationTypeList" :key="item.id" :label="item.bizValue" :value="Number(item.bizKey)">
                    </el-option>
                  </el-select>
                  <!-- 文本域 -->
                  <el-input v-if="item.type === 'textarea'" type="textarea" :rows="2" :placeholder="item.placeholder" v-model="item.value" style="width: 400px;"></el-input>
                  <!-- 单选 -->
                  <el-radio-group  v-if="item.type === 'radio'" v-model="item.value">
                    <el-radio  :label="1">上架</el-radio>
                    <el-radio  :label="0">下架</el-radio>
                  </el-radio-group>
                  <!-- 上传图片 -->
                  <el-upload v-if="item.type === 'upload'" 
                    action="#"
                    list-type="picture-card"
                    :on-preview="(file)=>{return handlePictureCardPreview(file, item)}"
                    :auto-upload="false"
                    :file-list="uploadList(item.name)"
                    :on-change="(file, file_list)=>{return handleChangeImgs(file, file_list, item.name)}"
                    :on-remove="(file, file_list)=>{return handleRemoveImgs(file, file_list, item)}"
                    :limit="1"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog v-if="item.type === 'upload'" :visible.sync="dialogVisible" append-to-body>
                    <img width="100%" :src="dialogImgUrl"/>
                  </el-dialog>
                  <!-- 视频教程上传 -->
                  <el-upload v-if="item.type === 'uploadVedio'"
                    action="#"
                    list-type="picture-card"
                    :on-preview="(file)=>{return handlePictureCardPreview(file, item)}"
                    :auto-upload="false"
                    :file-list="uploadList(item.name)"
                    :on-change="(file, file_list) => handleChangeVideo(file, file_list, item.name)"
                    :on-remove="(file, file_list) => handleRemoveVideo(file, file_list, item)"
                    :limit="1"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog v-if="item.type === 'uploadVedio'"  :visible.sync="dialogVideoVisible" append-to-body>
                    <video width="100%" controls :src="dialogVideoUrl"></video>
                  </el-dialog>
                <!-- 嵌套 -->
                  <div v-if="item.children" style="height: 32px;"></div>
                  <div class="children" v-for="(subItem) in item.children" :key="subItem.id">
                    <div class="title">{{ subItem.label }}</div>
                    <el-input v-model="subItem.value" maxlength="998" :placeholder="subItem.placeholder" style="width: 400px;"></el-input>
                  </div>
                </el-form-item>
              </el-form>
            </el-collapse-item>
            <el-collapse-item  name="2">
              <template slot="title">
               <b>Android手机厂商配置</b><i class="header-icon el-icon-info"></i>
              </template>
              <el-form :model="dialogBrandForm"   size="small" label-width="140px">
                <el-form-item>
                  <el-button type="primary" size="small" @click="handleAddBarnd">新增厂商</el-button>
                </el-form-item>
                <div v-for="(item,index) in dialogBrandForm.brandList " :key="index">
                  <el-form-item label="厂商名称：" >
                    <el-input v-model="item.name" placeholder="移动应用厂商名称"></el-input>
                  </el-form-item>
                  <el-form-item label="应用市场地址" placeholder="应用市场地址" >
                    <el-input style="width: 400px;" v-model="item.config.officialWebsiteAddress" placeholder="Android应用市场网站地址"></el-input>
                  </el-form-item>
                  <el-divider v-if="dialogBrandForm.brandList.length-1 !== index">分割线</el-divider>
                </div>
              </el-form>
            </el-collapse-item>
          </el-collapse>
        <div class="btn">
          <el-button size="mini"
            type="primary"
            @click="handleEdit"
            v-auth="'APPS_PCHOTUPGRADE_EDIT'">保存</el-button>
          <el-button size="mini"
            @click="onDialogClose"
            v-auth="'APPS_PCHOTUPGRADE_EDIT'">取消</el-button>
        </div>
      </div>
    </el-dialog>
     <!-- 操作日志 -->
      <OptionLog ref="optionLog" :columnConfig="optionLogColumn" @reload="reloadOpt" :closeBtn="false">
          <template #type="{ row }">
            <div>
              <!-- 操作类型(1-新增, 2-修改, 3-删除 -->
              <span v-if="row.type === 1">新增</span>
              <span v-if="row.type === 2">修改</span>
              <span v-if="row.type === 3">删除</span>
            </div>
          </template>
      </OptionLog>
  </div>
</template>
<script>
import { putFile } from '@/api/app'
import { addListContent, updateListContent, getListContent, deleteListContent, getListContentDetail, getLogList } from '@/api/pullApplicationManage/index.js'
import { getApps } from '@/api/index.js'
import OptionLog from "@/components/OptionsLog/optionLog.vue";
import { cloneDeep } from 'lodash'
export default {
  name: 'listContentManage',
  components: {
    OptionLog
  },
  data () {
    return {
       activeNames: ['2'],
       dialogBrandForm:{
          brandList: [
            {
              "name":"",
              "config":{
                "officialWebsiteAddress":""
              }
            }
          ]
       },
       /** 操作日志配置列 */
      optionLogColumn: [
        {
          prop: "operateTime",
          label: "操作时间",
        },
        {
          prop: "operator",
          label: "操作人",
        },
        {
          prop: "type",
          label: "操作类型",
          slot: "type",
        }
      ],
      // 查询条件
      searchForm: {},
      // 字体大小
      formSize: "small",
      tableData: [],
      pagination: {
        // 当前页 
        current: 1,
        // 单页数量
        size: 10,
        // 列表总数量
        total: 0
      },
      // 新增/编辑弹窗  
      visible: false,
      // 新增/编辑框内容
      dialogForm: [
        {
          label: '应用名称：',
          value: '',
          name: 'name',
          type: 'input',
          placeholder: '应用名称',
          id: 1,
        },
        {
          label: '应用类型：',
          value: '',
          name: 'type',
          type: 'select',
          id: 2
        },
        {
          label: '描述：',
          value: '',
          name: 'description',
          type: 'input',
          placeholder: '按照顺序进行显示, 相同数字按顺序排序',
          id: 3
        },
        {
          label: 'ICON：',
          value: '',
          name: 'icon',
          type: 'upload',
          id: 4
        },
        {
          label: '过渡页前置背景图：',
          value: '',
          name: 'backgroundImg',
          type: 'upload',
          id: 5
        },
        {
        label: '单片跳转链接：',
        name: 'link',
        id: 8,
        children: [{
          label: 'Android_Package：',
          value: '',
          name: 'androidPackage',
          type: 'input',
          placeholder: '输入Android端的App包名'
        },{
          label: 'App跳转地址：',
          value: '',
          name: 'officialWebsiteAddress',
          type: 'input',
          placeholder: '输入Android端的App首页跳转地址'
        },{
          label: 'Android_pad_Package：',
          value: '',
          name: 'androidPadPackage',
          type: 'input',
          placeholder: '输入Android_pad端的App包名'
          },{
            label: 'Android其他跳转地址：',
            value: '',
            name: 'androidOtherScheme',
            type: 'input',
            placeholder: '输入Android的scheme链接'
          },{
          label: 'iOS_Scheme：',
          value: '',
          name: 'iosScheme',
          type: 'input',
          placeholder: '输入iOS端的Scheme链接'
        },{
          label: 'iOS_app_link：',
          value: '',
          name: 'appLink',
          type: 'input',
          placeholder: '输入iOS端的通用跳转链接'
        },{
          label: 'iPad_Scheme：',
          value: '',
          name: 'ipadScheme',
          type: 'input',
          placeholder: '输入ipad端的Scheme链接'
        },{
            label: 'IOS其他跳转地址：',
            value: '',
            name: 'iosOtherScheme',
            type: 'input',
            placeholder: '输入IOS的scheme链接'
          }]
        },
        {
          label: '视频教程：',
          value: '',
          name: 'guideVideoUrl',
          type: 'uploadVedio',
          id: 11
        },
        {
          label: '支付页跳转code：',
          value: '',
          name: 'buySceneCode',
          type: 'input',
          placeholder: '输入支付页跳转code：',
          id: 9
        }
        ,{
          label: '备注：',
          value: '',
          name: 'remark',
          type: 'textarea',
          placeholder: '输入文案',
          id: 10
        }
      ],
      // 新增/编辑放大的图片
      dialogImgUrl: '',
      /// 新增/编辑放大的图片显示/隐藏
      dialogVisible: false,
      rules: {
        // 内容名称
        name: [
          { 
            required: true,
            validator: (rule, value, callback) => {
              let formValue = this.dialogForm.find(item => item.name === rule.field).value;
              if (!formValue) {
                return callback(new Error('此该项为必填项'));
              }
              callback();
            },
            trigger: 'change'
          }
        ],
        // 应用类型
        type: [
          { 
            required: true,
            validator: (rule, value, callback) => {
              let formValue = this.dialogForm.find(item => item.name === rule.field).value;
              if (!formValue) {
                return callback(new Error('此该项为必填项'));
              }
              callback();
            },
            trigger: 'change'
          }],
        // 描述
        description: [{max: 99, message: '输入内容不能超过 99 个字符', trigger: 'blur'}],
        // 跳转CODE
        buySceneCode: [{max: 99, message: '输入内容不能超过 999 个字符', trigger: 'blur'}],
        // 跳转链接
        link: [
          {
            required: true,
            validator: (rule, value, callback) => {
              let formChild = this.dialogForm.find(item => item.name === rule.field).children;
              let obj = {}
              formChild.forEach(ele => {
                obj[ele.name] = ele.value
              });
              if (!obj.androidPackage) {
                return callback(new Error('Android_Package该项为必填项'));
              }
              if (!obj.officialWebsiteAddress) {
                return callback(new Error('App跳转地址该项为必填项'));
              }
              if (!obj.iosScheme && !obj.appLink) {
                return callback(new Error('iOS_Scheme：与iOS_app_link至少填一个'));
              }
              callback();
            },
          }
        ],
        // icon
        icon: [
          {
            required: true,
            validator: (rule, value, callback) => {
              let formValue = this.dialogForm.find(item => item.name === rule.field).value;
              if (!formValue) {
                return callback(new Error('内容图片必须上传'));
              }
              callback();
            },
            trigger: 'change'
          }
        ]
      },
      loading: false,
      // icon
      icon: [],
      // 背景图
      backgroundImg: [],
      // 应用类型
      aplicationTypeList: [],
      // 修改ID
      editId: '',
      // 视频预览URL
      dialogVideoUrl: '',
      dialogVideoVisible: false,
      guideVideoUrl: []
    }
  },
  async created() {
    // 获取应用类型字典
    await this.getAplicationTypeList()
    // 获取榜单列表
    this.getListContent()
  },
  methods: {
    /** 查看日志 */
    async viewLog(row) {
      console.log("查看日志", row.id);
      const optSearch = this.$refs.optionLog.searchParams;
      const { data } = await getLogList({
        ...optSearch,
        subjectId: row.id,
      });
      console.log("查看日志的响应", data);
      const list = cloneDeep(data.data.records);
      optSearch.total = data.data.total;

      this.$refs.optionLog.show(list, row.id);

    },
    /** 日志分页 */
    async reloadOpt(id) {
      console.log("日志分页", id);
      const optSearch = this.$refs.optionLog.searchParams;
      const { data } = await getLogList({
        ...optSearch,
        subjectId: id,
      });
      console.log("查看日志的响应", data);
      const list = cloneDeep(data.data.records);
      this.$refs.optionLog.list = list;
      this.$refs.optionLog.searchParams.total = data.data.total;
    },
    // 返回图片
    uploadList (name) {
      return this[name] || []
    },
    // 返回应用类型
    getApplicationDes (type) {
       let obj = this.aplicationTypeList.find((item)=>{
         return Number(item.bizKey) === type
      })
      return obj && obj.bizValue
    },
    // 获取字典项
    async getAplicationTypeList () {
      await getApps('aplication_type').then((data)=>{
        let res = data.data.data
        let arr = []
        res.forEach((item)=>{
          arr.push({bizKey: item.dictKey, bizValue:item.dictValue})
        })
        this.aplicationTypeList = arr
      }).catch(()=>{})
    },
    // 获取应用列表
    getListContent (type) {
      if (type) {
        this.pagination.current = 1
      }
      let params = { ...this.searchForm }
      params.current = this.pagination.current
      params.size = this.pagination.size
      getListContent(params).then((data)=>{
        this.tableData = data.data.data.records
        this.pagination.current = data.data.data.current
        this.pagination.total = data.data.data.total
        this.pagination.size = data.data.data.size
      }).catch((err)=>{
        console.log(err);
      })
    },
    // 列表按钮点击
    handleClick (row, type) {
      this.type = type
      if (type===1) {
        // 新增
        this.visible = true
      } else if (type===2) {
        // 编辑
        this.visible = true
        const params = {
          id: row.id
        }
        this.editId = row.id
        // 获取拉起应用详情
        getListContentDetail(params).then((data)=>{
          let res = data.data.data
          this.dialogForm.map((item)=>{
            if (item.type === 'upload' || item.type === 'uploadVedio') {
              // 记录已上传的数据
              this[item.name] = res[item.name] ? [{url: res[item.name]}] : []
            }
            if (item.children) {
              item.children.forEach(subItem => {
                subItem.value = res[subItem.name]
              });
            } else {
              item.value = res[item.name]
            }
          })
          if(res.brandSetting!==''){
            this.dialogBrandForm.brandList =  JSON.parse(res.brandSetting);
          }
        }).catch(()=>{
          this.$message.error('获取应用详情失败')
        })
      } else if (type===3) {
        // 删除
        const param = {
          ids: [row.id]
        }
        this.$confirm("此操作将永久删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(()=>{
          deleteListContent(param).then(()=>{
            this.$message.success('删除成功')
            this.getListContent()
          }).catch(()=>{
            this.$message.error('删除失败')
          })
        }).catch(()=>{})
      }
    },
    // 改变单页数量
    handleSizeChange(val) {
      this.pagination.size = val
      this.getListContent()
    },
    // 跳转指定页面
    handleCurrentChange(val) {
      this.pagination.current = val
      this.getListContent()
    },
    handleClickItem(){
      this.$nextTick(()=>{
        let domImageMask = document.querySelector(".el-image-viewer__mask");  // 获取遮罩层dom
        if (!domImageMask) {
        return;
        }
        domImageMask.addEventListener("click", () => {
        // 点击遮罩层时调用关闭按钮的 click 事件
        document.querySelector(".el-image-viewer__close").click();
        });
      })
    },
    // 关闭新增/编辑弹窗
    onDialogClose () {
      this.visible = false
      this.loading = false
      this.resetData()
    },
    // 删除图片
    handleRemoveImgs(file, fileList, item) {
      item.value = ''
      this[item.name] = []
    },
    // 预览
    handlePictureCardPreview(file, item) {
      if (item.type === 'upload') {
        this.dialogVisible = true;
        this.dialogImgUrl = item.value
      } else {
        this.dialogVideoVisible = true;
        this.dialogVideoUrl = item.value
      }
    },
    //上传图片
    handleChangeImgs(file, fileList, name) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      // 指定jpg png格式
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
        this[name] = []
        this.$forceUpdate()
        return
      }
      this[name] = [fileList[fileList.length - 1]]
      const formData = new FormData()
      formData.append('file', file.raw)
      putFile(formData).then((res) => {
        if (res.data.code === 200) {
          this.dialogForm.some((item) => {
            if (item.name === name) {
              this[name] = [{url: res.data.data.link}]
              item.value = res.data.data.link
              this.$refs[name][0].clearValidate();
              return true
            }
          })
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 新增/修改保存
    handleEdit () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.loading = true
          let obj = {}
          // 组装数据
          this.dialogForm.forEach((item) => {
            if (item.children) {
              item.children.forEach((subItem)=>{
                obj[subItem.name] = subItem.value
              })
            } else {
              obj[item.name] = item.value
            }
          })
          //添加厂商配置
          let brandSetting = [];
          this.dialogBrandForm.brandList.forEach((item)=>{
            let brandData = {
              name: item.name,
              "config": item.config
            };
            brandSetting.push(brandData);
          })
          obj["brandSetting"] = JSON.stringify(brandSetting);

          if (this.type === 1) {
            //新增
            addListContent(obj).then(()=>{
              this.onDialogClose()
              this.getListContent()
            }).catch((err)=>{
              window.console.log(err);
              this.loading = false
            })
          } else {
            obj.id = this.editId
            // 编辑
            updateListContent(obj).then(()=>{
              this.getListContent()
              this.onDialogClose()
            }).catch((err)=>{
              window.console.log(err);
              this.loading = false
            })
          }
        } else {
          console.log("表单校验失败");
          return false;
        }
      });
    },
    // 重置数据
    resetData () {
      this.dialogForm.map((item)=>{
        if (item.children) {
          item.children.map((subItem)=>{
            subItem.value = ''
          })
        } else {
          if (item.type === 'upload' || item.type === 'uploadVedio') {
            this[item.name] = []
          }
          item.value = ''
        }
      })
      this.dialogBrandForm.brandList = [];
    },
    handleRemoveVideo(file, fileList, item) {
      item.value = ''
      this[item.name] = []
    },
    handleChangeVideo(file, fileList, name) {
      const isLt500M = file.size / 1024 / 1024 < 500;
      if (!isLt500M) {
        this.$message.error('上传视频大小不能超过 500MB!');
        this[name] = [];
        this.$forceUpdate();
        return;
      }
      this.createThumbnail(file.raw, name);
      const formData = new FormData();
      formData.append('file', file.raw);
      putFile(formData).then((res) => {
        if (res.data.code === 200) {
          this.dialogForm.some((item) => {
            if (item.name === name) {
              item.value = res.data.data.link;
              this.dialogVideoUrl = res.data.data.link;
              return true;
            }
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    createThumbnail(videoFile, name) {
      const url = URL.createObjectURL(videoFile);
      const video = document.createElement('video');
      video.src = url;
      video.currentTime = 1;
      video.onloadeddata = () => {
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        this.videoThumbnail = canvas.toDataURL('image/png');
        this[name] = [{ url: this.videoThumbnail }];
        URL.revokeObjectURL(url); // Clean up
      };
    },
    handleAddBarnd(){
      this.dialogBrandForm.brandList.push({
        "name":"",
        "config":{
          "officialWebsiteAddress":""
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.listContentManage {
  .query-form-wrap {
    padding: 16px;
  }
  .block {
    text-align: right;
    margin: 16px 0;
  }
}

.el-input__inner {
  width: 250px !important;
}
.dialog-content-wrap {
  .children {
    display: flex;
    margin: 10px 0 20px -120px;
    .title {
      text-align: right;
      width: 150px;
      margin-right: 10px;
    }
  }
}

.btn {
  text-align: right;
}
</style>